var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(!_vm.forgetPassword)?_c('lo-gin'):_c('forget-password'),_c('p',{staticClass:"text-center mt-3"},[_c('v-btn',{attrs:{"color":"primary","small":""},on:{"click":function($event){_vm.forgetPassword = !_vm.forgetPassword}}},[_vm._v(_vm._s(_vm.forgetPassword ? 'login' : 'forgot password'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }